import { z } from 'zod';

export const Z_INT = (minError: string = undefined) => z
  .coerce
  .number({ error: minError })
  .min(1, { error: minError })
  .int();